// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"85b21532","304":"85b21532","744":"85b21532"}[chunkId] + ".chunk.css";
};